import { auth } from '@/api'

export default {
  async mounted() {
    await auth.getSelfInfo()
  },
}
